// src/pages/ResetPasswordPage.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import PasswordResetPopup from '../../../components/popup/ResetPasswordPopup.jsx';

const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/login'); 
    };

    return (
        <div>
            <PasswordResetPopup token={token} onClose={handleClose} />
        </div>
    );
};

export default ResetPasswordPage;
